<template>
  <textarea
    :id="field.handle"
    :name="name"
    class="
      form-input peer px-0 h-12 w-full bg-transparent border-0 border-b border-purple-dark/25 transition duration-300
      focus:ring-0 focus-visible:ring-0 focus:outline-0 focus-visible:outline-0 focus:border-purple-dark
      group-hover:border-purple-dark
      md:text-lg
    "
    @change="emits('update', $event)"
    :required="isRequired"
    placeholder=""
  />

  <label
    :for="field.handle"
    class="
      absolute top-0 left-0 text-purple-dark/50 leading-none transition duration-300 origin-left will-change-transform
      group-hover:text-purple-dark group-hover:scale-75
      peer-focus:text-purple-dark peer-focus:scale-75
      peer-[:not(:placeholder-shown)]:text-purple-dark peer-[:not(:placeholder-shown)]:scale-75
      md:text-lg"
  >
    {{ label }}<span v-if="isRequired">*</span>
  </label>
</template>

<script setup lang="ts">
import type { Field } from '~/statamic/types/form';

const props = defineProps<{
  name: string;
  field: Field;
  rules: string[];
  label?: string;
}>();

const emits = defineEmits([
  'update',
]);

const isRequired = props.rules.includes('required');
</script>
